module.exports = __webpack_public_path__ + "img/ar.13dc7d66.svg";